import {
    AfterViewInit,
    Component,
    EventEmitter,
    forwardRef,
    Input,
    OnInit,
    Output,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseFormControlComponent } from '../../../components/forms/base-form-control.component';
import { LsqInputComponent } from '../../../components/forms/input/lsq-input.component';
import { KeyCodes } from '../../../constants/keycodes.constants';
import { Regex } from '../../../constants/regex.constants';
import { Utilities } from '../../../utilities/utilities.helper';

@Component({
    selector: 'lsq-page-input',
    template: `
        <lsq-input
            [name]="name"
            [label]="label"
            [ariaLabel]="ariaLabel"
            class="lsq-page-input"
            [basicLabel]="basicLabel"
            [floatLabel]="floatLabel"
            [innerLabel]="innerLabel"
            [type]="type"
            [min]="min"
            [max]="max"
            (focus)="setSelectionRange($event)"
            (blur)="pageUpdated.emit(inputTextAsNumber)"
            [parentClass]="parentClass"
            [inputClass]="inputClass"
            [handleKeypress]="handleKeypress"
        >
        </lsq-input>
    `,
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./lsq-page-input.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => LsqPageInputComponent),
            multi: true
        }
    ]
})
export class LsqPageInputComponent extends BaseFormControlComponent<string>
    implements AfterViewInit, OnInit {
    @Input() public name = 'pageNumber';
    @Input() public label?: string;
    @Input() public ariaLabel = 'Go To Page';
    @Input() public basicLabel = false;
    @Input() public floatLabel = false;
    @Input() public innerLabel = false;
    @Input() public type = 'number';
    @Input() public maxLength?: string;
    @Input() public minLength?: string;
    @Input() public min = 1;
    @Input() public max?: number;
    @Input() public parentClass?: string;
    @Input() public inputClass = 'paging-input';
    @ViewChild(LsqInputComponent, { static: true }) public pageInput: LsqInputComponent;
    @Output() public pageUpdated = new EventEmitter<number>();
    public inputElement: HTMLInputElement;
    public inputText: string;

    public ngOnInit(): void {
        this.handleKeypress = this.handleKeypress.bind(this);
    }

    public ngAfterViewInit(): void {
        this.inputElement = this.elementRef.nativeElement.querySelector('input');
        this.pageInput.registerOnChange((val) => (this.inputText = val));
    }

    public handleKeypress(event: KeyboardEvent, model: any): void {
        const pattern = Regex.Number;
        const inputChar = String.fromCharCode(event.charCode);

        // Check if non-numeric char
        if (!pattern.test(inputChar)) {
            // Invalid character, prevent input
            event.preventDefault();
        }

        if (event.charCode === KeyCodes.Enter) {
            this.inputElement.blur();
        }
    }

    public setSelectionRange(event: MouseEvent): void {
        // Needs to be put in setTimeout to work properly in Safari.
        Utilities.executeAfterRender(() => (this.inputElement as any).select());
    }

    public get inputTextAsNumber(): number {
        return +this.inputText;
    }

    // Jumper these ControlValueAccessor functions to the underlying lsq-input.
    public writeValue(model: string): void {
        this.pageInput.writeValue(model);
    }
    public registerOnChange(fn: (_: string) => void): void {
        this.pageInput.registerOnChange(fn);
    }
    public registerOnTouched(fn: () => void): void {
        this.pageInput.registerOnTouched(fn);
    }
}
